'use client'
import ExpandPanel from "@/components/ExpandPanel"
import { PropsWithClassname } from "@/types"
import { Chip } from "@/ui/Chip"
import { useSearchParams } from "next/navigation"
import { useCallback, useState } from "react"
import { SEARCH_TAG_KEY } from "./Constants"
import { useUserStore } from "@/store/useUserStore"



export const TagSelector = ({
  transitionPush,
  tags,
  ...other }:
  PropsWithClassname & {
    transitionPush: (url: string, opt: { key: string, val: string }) => void
    tags: any[]
  }) => {



  const search = useSearchParams()
  const tagsQuery = search.get('tags')
  const isLogined = useUserStore(state => state.isLogined)
  let initTags = []
  try {
    if (tagsQuery) initTags = JSON.parse(tagsQuery)
  } catch {
  }

  const [selectedTags, setSelectedTags] = useState<Set<Number>>(new Set<Number>(initTags))

  const [isAll, setAll] = useState(initTags.length === 0)

  const setSelectCB = useCallback((id: number) => {
    if (selectedTags.has(id)) {
      selectedTags.delete(id)
    } else {
      selectedTags.clear()
      selectedTags.add(id)
    }
    const newSelect = new Set(selectedTags)

    if (newSelect.size === 0) {
      transitionPush(`./`, { key: SEARCH_TAG_KEY, val: null! })
      setAll(true)
    } else {
      transitionPush(`./`, { key: SEARCH_TAG_KEY, val: JSON.stringify([...newSelect]) })

      setAll(false)
    }
    setSelectedTags(newSelect)
  }, [selectedTags, isAll, tags])



  return (<>
    <ExpandPanel {...other}>
      <Chip
        className="transition-all"
        selectValue={isAll}
        setSelectValue={v => {
          if (v) {
            setAll(true)
            setSelectedTags(new Set())
            transitionPush(`./`, { key: SEARCH_TAG_KEY, val: null! })
          }
        }}
      >All</Chip>


      {tags?.map(item =>
        <Chip
          key={item.cid}
          className="transition-all"
          selectValue={selectedTags.has(item.cid)}
          setSelectValue={(val: boolean) => setSelectCB(item.cid)}
        >
          {item.name}
        </Chip>
      )}
    </ExpandPanel>
  </>
  )
}


